// src/filters/order.js
export function orderStatusText (item) {
    let text = ''
    if (item.afterState === '4' || item.afterState === 4) {
        text = '退款成功'
    } else if (item.afterState === '5' || item.afterState === 5) {
        text = '退款失败'
    } else if (item.afterState === '2' || item.afterState === 2) {
        text = '退款中'
    } else if (item.afterState === '8' || item.afterState === 8) {
        text = '退货完成，拒绝退款'
    } else if (item.state === 1 || item.state === '1') {
      text = '等待付款'
    } else if (item.state === 2 || item.state === '2') {
      text = '等待发货'
    } else if (item.state === 3 || item.state === '3') {
      text = '等待收货'
    } else if (item.state === 4 || item.state === '4') {
      text = '交易完成'
    } else if (item.state === 5 || item.state === '5') {
      text = '已关闭'
    } else if (item.state === 6 || item.state === '6') {
      text = '待成团'
    } else if (item.state === 7 || item.state === '7') {
      text = '售后中'
    }
    return text
  }



// WEBPACK FOOTER //
// ./src/filters/order.js